import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { BsPlus } from "react-icons/bs";
import styled from "styled-components";
import { AiFillInfoCircle } from "react-icons/ai";
import DateRangePicker from "@wojtekmaj/react-daterange-picker/dist/DateRangePicker";
import { KeyCode, SearchBox } from "./Helper2";
import { GetDatePreriod, GetThaiZoneDate, XButton } from "./Helper";

export const TopToolBar = (props) => {
  const {
    onAddNew,
    title,
    searchHandler,
    icon,
    children,
    addNewTitle,
    refTo,
    disableEmpty,
    effectOnChanged,
    dateFilter,
    dateFilterTitle,
  } = props;
  const [text, setText] = useState();
  const [dateRangeValues, changeDateRange] = useState([new Date(), new Date()]); // props.dateRange;

  useEffect(() => {
    if (dateFilter) {
      searchHandler(text, dateRangeValues);
    }
  }, [dateRangeValues]);

  return (
    <div className="toolbar-add-new">
      {onAddNew && (
        <Button onClick={onAddNew}>
          <BsPlus /> {addNewTitle ?? "เพิ่มใหม่"}
        </Button>
      )}
      <DivButtonGroup>
        {children}

        {dateFilter === true ? (
          <DivCaption>
            <span style={{ paddingInline: "5px" }}>ระหว่าง:</span>
            <DateRangePicker
              onChange={changeDateRange}
              // onChange={(e) =>
              //   changeDateRange([GetThaiZoneDate(e[0]), GetThaiZoneDate(e[1])])
              // }
              value={dateRangeValues}
              format="dd/MM/yyyy"
              locale="th-Th"
              closeCalendar={false}
              clearIcon={null}
            />
            <XButton onClick={(e) => changeDateRange(GetDatePreriod("TODAY"))}>
              Today
            </XButton>
            <XButton
              onClick={(e) => changeDateRange(GetDatePreriod("THISMONTH"))}
            >
              This Month
            </XButton>
          </DivCaption>
        ) : (
          <></>
        )}
      </DivButtonGroup>

      <DivCaption>
        {icon}
        <label className="list-title-label">{title}</label>
      </DivCaption>
      {searchHandler ? (
        <div>
          <SearchBox
            text={[text, setText]}
            refTo={refTo}
            onKeyDown={(e) => {
              switch (e.keyCode) {
                case KeyCode.ESC:
                  setText("");
                  if (!disableEmpty) {
                    searchHandler && searchHandler("");
                  }
                  break;
                case KeyCode.ENTER:
                  if (!text && disableEmpty) {
                    return;
                  }
                  searchHandler && searchHandler(text, dateRangeValues);
                  break;

                default:
                  searchHandler &&
                    effectOnChanged &&
                    searchHandler(text, dateRangeValues);
                  break;
              }
            }}
          />
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

const DivButtonGroup = styled.div`
  display: flex;
  flex: 1;

  /* justify-content: space-around; */
  margin-inline: 10px;
`;
const DivCaption = styled.div`
  display: flex;
  flex: 1;
  color: var(--x-fore-banner);
  align-items: center;
  padding-inline: 5px;
  flex-wrap: wrap;
`;

export const TobBanner = (props) => {
  const { title, icon } = props;

  return (
    <DivBanner>
      <DivCaption style={{ paddingBlock: "2px" }}>
        {
          <AiFillInfoCircle
            color="var(--icon-fore)"
            size={20}
            style={{ marginBlockStart: "3px", marginInline: "5px" }}
          />
        }
        <LabelBanner>{title}</LabelBanner>
      </DivCaption>
    </DivBanner>
  );
};

const DivBanner = styled.div`
  display: flex;

  background: var(--tb-bg-header);

  color: var(--x-fore-banner-2);
  font-size: 18px;
  padding-inline: 10px;
  padding-block: 5px;
  border-radius: 5px;
`;
const LabelBanner = styled.label`
  color: var(--tb-fore-header);
`;
